import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalObservables } from '../../../../../app.global.observer';
import { HelperService } from '../../../services/helper.service';
import { Global } from '../../../../../app.global';
import { KeyDescriptionViewModel } from '../../../viewmodels/keyDescriptionViewModel';

import {
  RadioQuestionModel,
  SelectQuestionModel,
  MultipleQuestionModel,
  ExplainQuestionModel,
} from '../../../viewmodels/policy-item.model';
import { PermitResidentCopy } from '../../../helper/textcopy/policies.text';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'resident-policy',
  templateUrl: './resident.component.html',
})
export class ResidentComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSavePolicies = new EventEmitter();
  policiesAnswersSetted = new Subscription();
  policiesAnswers: any = this.global.policiesAnswers;

  textCopy = PermitResidentCopy;
  permitType = new RadioQuestionModel();
  reconsider = new RadioQuestionModel();
  failDisplay = new SelectQuestionModel();
  cancel = new RadioQuestionModel();
  virtualPermits = new MultipleQuestionModel();
  explain = new ExplainQuestionModel();

  constructor(
    public global: Global,
    private globalObs: GlobalObservables,
    private helpServ: HelperService
  ) {}

  ngOnInit() {
    this.setPermitTypeQuestion();
    this.setReconsiderQuestion();
    this.setFailDisplayQuestion();
    this.setCancelQuestion();
    this.setVirtualPermitsQuestion();
    this.setExplainQuestion();

    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.onPoliciesAnswersSetted();
    } else {
      this.setSelectedValues();
    }
  }

  setPermitTypeQuestion() {
    this.permitType.data = {
      title: this.textCopy.permitTypeTitle,
      includeTitle: true,
      answers: [
        { text: 'paper', value: '0' },
        { text: 'virtual', value: '1' },
        { text: 'both of the above types', value: '2' },
      ],
    };
  }
  onPermitTypeSelected(answerValue) {
    this.permitType.valueSelected = answerValue;
  }

  setReconsiderQuestion() {
    this.reconsider.data = {
      title: this.textCopy.reconsiderTitle,
      includeTitle: true,
      answers: [
        { text: 'yes', value: 'y' },
        { text: 'yes – provided it was displayed (even if it was wrongly displayed)', value: 'd' },
        { text: 'no', value: 'n' },
      ],
    };
  }
  onReconsiderSelected(answerValue) {
    this.reconsider.valueSelected = answerValue;
  }

  setFailDisplayQuestion() {
    this.failDisplay.data = {
      title: this.textCopy.failDisplayTitle,
      includeTitle: true,
      answers: [
        { id: '0', value: '1' },
        { id: '1', value: '2' },
        { id: '2', value: '3' },
      ],
    };
  }
  onFailDisplaySelected(answerValue) {
    this.failDisplay.valueSelected = answerValue;
  }

  setCancelQuestion() {
    this.cancel.data = {
      title: this.textCopy.cancelTitle,
      includeTitle: true,
      answers: [
        { text: 'Yes', value: '0' },
        { text: 'Yes - if the permit, when issued, covers the zone and vehicle', value: '1' },
        {
          text: 'Yes - if the permit, when issued, covers the zone and vehicle and PCN date',
          value: '2',
        },
        { text: 'No', value: '3' },
      ],
    };
  }
  onCancelSelected(answerValue) {
    this.cancel.valueSelected = answerValue;
  }

  setVirtualPermitsQuestion() {
    this.virtualPermits = {
      data: {
        questions: [
          {
            id: 0,
            text: 'Wrong VRM detail (a wrong digit or two)',
            answers: [
              { id: 'n', value: '0' },
              { id: '0', value: '1' },
              { id: '1', value: '2' },
              { id: '2', value: '3' },
            ],
          },
          {
            id: 1,
            text: "Wrong vehicle (person's second car)",
            answers: [
              { id: 'n', value: '0' },
              { id: '0', value: '1' },
              { id: '1', value: '2' },
              { id: '2', value: '3' },
            ],
          },
          {
            id: 2,
            text: "Wrong vehicle (person's previous car, now sold)",
            answers: [
              { id: 'n', value: '0' },
              { id: '0', value: '1' },
              { id: '1', value: '2' },
              { id: '2', value: '3' },
            ],
          },
          {
            id: 3,
            text: 'Wrong zone or location',
            answers: [
              { id: 'n', value: '0' },
              { id: '0', value: '1' },
              { id: '1', value: '2' },
              { id: '2', value: '3' },
            ],
          },
          {
            id: 4,
            text: 'Wrong start date / parked before start date',
            answers: [
              { id: 'n', value: '0' },
              { id: '0', value: '1' },
              { id: '1', value: '2' },
              { id: '2', value: '3' },
            ],
          },
        ],
      },
      active: true,
      valuesSelected: [],
    };
  }
  onVirtualPermitsSelected(answerValue) {
    this.virtualPermits.valuesSelected = answerValue;
  }

  setExplainQuestion() {
    this.explain.data = {
      title: this.textCopy.explainTitle,
      includeTitle: true,
      name: "'Resident permit holders'",
      validList: ['0', '1', '2', '3', '4', '5', '7', '8', '9', '10'],
      exampleItem: "Residents' permits",
    };
  }
  onExplainSelected(answerValue) {
    this.explain.valueSelected = answerValue.answerSelected;
    this.explain.validationSelected = answerValue.validationSelected;
    this.explain.validationText = answerValue.validationText;
  }

  setSelectedValues() {
    this.permitType.valueSelected = this.policiesAnswers['10_1'];
    this.reconsider.valueSelected = this.policiesAnswers['10_4'];
    this.failDisplay.valueSelected = this.policiesAnswers['10_3'];
    this.cancel.valueSelected = this.policiesAnswers['10_2'];
    this.virtualPermits.valuesSelected = [
      { id: 0, value: this.policiesAnswers['10_5_1'] },
      { id: 1, value: this.policiesAnswers['10_5_2'] },
      { id: 2, value: this.policiesAnswers['10_5_3'] },
      { id: 3, value: this.policiesAnswers['10_5_4'] },
      { id: 4, value: this.policiesAnswers['10_5_5'] },
    ];
    this.explain.validationSelected = this.policiesAnswers['10_8'];
    this.explain.valueSelected = this.policiesAnswers['10_7'];
    this.explain.validationText = this.policiesAnswers['10_9'];
  }

  onPoliciesAnswersSetted() {
    this.policiesAnswers = this.global.policiesAnswers;
    this.policiesAnswersSetted = this.globalObs.onPoliciesAnswersSetted.subscribe(() => {
      this.setSelectedValues();
    });
  }

  submitPolicyCategory() {
    let policyList = new Array<KeyDescriptionViewModel>();
    policyList = [
      { id: '10_1', description: this.permitType.valueSelected },
      { id: '10_4', description: this.reconsider.valueSelected },
      { id: '10_3', description: this.failDisplay.valueSelected },
      { id: '10_2', description: this.cancel.valueSelected },
      { id: '10_8', description: this.explain.validationSelected },
      { id: '10_7', description: this.explain.valueSelected },
      { id: '10_9', description: this.explain.validationText },
    ];

    this.virtualPermits.valuesSelected.forEach((selectedValue, index) => {
      policyList.push({ id: `10_5_${index + 1}`, description: selectedValue.value });
    });

    this.onSavePolicies.emit(policyList);
  }

  ngOnDestroy() {
    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.policiesAnswersSetted.unsubscribe();
    }
  }
}
